var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mwm-tou-body"},[(!_vm.touError)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.touData.body)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }